import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { type Country, getConfig } from '@/constants/config';
import useModal from '@/hooks/useModal';
import { withdrawMutationOptions as fiWithdrawMutationOptions } from '@/pages/Credit/FI/queries/withdrawMutation/withdrawMutation';
import type { WithdrawMutationOptions } from '@/pages/Credit/queries/withdrawMutationGeneric/types';
import { withdrawMutationOptions as seWithdrawMutationOptions } from '@/pages/Credit/SE/queries/withdrawMutation/withdrawMutation';
import { withdrawMutationOptions as ukWithdrawMutationOptions } from '@/pages/Credit/UK/queries/withdrawMutation/withdrawMutation';

type WithdrawMutationOptionsReturn = ReturnType<
  typeof fiWithdrawMutationOptions | typeof seWithdrawMutationOptions | typeof ukWithdrawMutationOptions
>;

const optionsMap: Record<Country, (options: WithdrawMutationOptions) => WithdrawMutationOptionsReturn> = {
  SE: seWithdrawMutationOptions,
  UK: ukWithdrawMutationOptions,
  FI: fiWithdrawMutationOptions,
};

const useWithdrawMutation = () => {
  const { openModal } = useModal();
  const navigate = useNavigate();

  const mutationOptions = optionsMap[getConfig().country]({ openModal, navigate });

  return useMutation(mutationOptions);
};

export default useWithdrawMutation;
